import { useMemo } from "react";
import { useAppSelector } from "app/store";

export interface TeamCapabilities {
  hasAuditCapability: boolean;
  hasNoticeCapability: boolean;
  hasLitigationCapability: boolean;
}

/** Which GaiaObject categories the SELECTED team has. */
export const useTeamCapabilities = (): TeamCapabilities => {
  const teamSettings = useAppSelector(
    (state) => state.teamSettings.selectedTeamMainMetaData,
  );
  const currentGuestTeam = useAppSelector(
    (state) => state.teamSettings.currentGuestTeam,
  );
  const headerSelectedTeam = useAppSelector(
    (state) => state.audits.headerSelectedTeam,
  );

  // Determine current team settings (for both members and guests)
  const currentTeamSettings = useMemo(() => {
    // If user is guest, get from current guest team
    if (headerSelectedTeam === "guest") {
      return currentGuestTeam?.selectedTeamMainMetaData;
    }

    return teamSettings;
  }, [headerSelectedTeam, currentGuestTeam, teamSettings]);

  return useMemo(() => {
    const has = (category: "audit" | "notice" | "litigation") =>
      Boolean(
        currentTeamSettings?.teamCustomAttributesSchema?.[category] ||
          currentTeamSettings?.enabledFeatures?.includes(
            category.toUpperCase(),
          ) ||
          currentTeamSettings?.enabledFeatures?.includes(category),
      );

    return {
      hasAuditCapability: has("audit"),
      hasNoticeCapability: has("notice"),
      hasLitigationCapability: has("litigation"),
    };
  }, [currentTeamSettings]);
};
